export const CustomLoader = (color) => {
  return (
    <div
      class="custom-loader mix-blend-normal size-2"
      style={`background: radial-gradient(farthest-side,#fff 94%,#0000) top/8px 8px no-repeat,conic-gradient(#0000 30%,#fff);`}
    ></div>
  )
}